import { createSelector } from 'reselect';

import { StateType } from '@redux/reducers';

const getBillingState = ({ publisherBillings }: StateType) => publisherBillings;

export const billingPublisherDetailsSelector = createSelector(
  [getBillingState],
  ({ billingDetails }) => billingDetails
);
export const billingPublisherAddressSelector = createSelector(
  [getBillingState],
  ({ billingAddress }) => billingAddress
);
